<template>

    <component
        v-if="ready"
        ref="page"
        :is="activeComponent"
        @update-url="updateURL">

    </component>

    <RelatedResourcesList
        ref="related"/>


</template>
<script>
export default {
    name : 'Search Module',
}
</script>
<script setup>

import { onMounted, computed, ref, inject, watch } from 'vue';
import { useStore }                                from "vuex";

import NoResult  from "./NoResult";
import Result    from "./Result";
import Searching from "./Searching";

import { useQuerystring }   from "./composables/URL";
import RelatedResourcesList from "./components/RelatedResourcesList";
import { debounce }         from 'lodash-es';

import KeydownEvents from './composables/KeydownEvents';

//INIT
let store         = useStore();
const querystring = useQuerystring();

let containerSearch = document.querySelector( "#container-search" );
//
// if (containerSearch)
// {
//     containerSearch.innerHTML = "";
// }


//DATA/REF
let ready       = ref( false );
let page        = ref( null );
let related     = ref( null );
let isSearching = ref( false );


//COMPUTED
let results         = computed( () => store.state.results );
let activeComponent = computed( () => results.value && results.value.length === 0 ? isSearching.value ? Searching : NoResult : Result );
let strSearchTerms  = computed( () => store.state.searchTerms );
let strSearchType   = computed( () => store.state.searchType );

const searchInput = document.querySelector( "#nav-search-input" );

let numberFilter = computed( () => store.state.checked.length );


watch( numberFilter, ( newCount, oldCount ) =>
{
    updateURL();
} );

//METHODS

function updateURL ()
{
    if ( 'URLSearchParams' in window )
    {
        let searchParams = new URLSearchParams( window.location.search );
        searchParams.set( "s", strSearchTerms.value ?? "" );

        if ( (strSearchType.value ?? "") !== "" )
        {
            searchParams.set( "type", strSearchType.value );
        } else
        {
            searchParams.delete( "type" );
        }

        searchParams.delete( "f" );

        let strNewPath = window.location.pathname + '?' + searchParams.toString();


        const filters = store.getters.checkedIds;

        if ( filters.length > 0 )
        {
            const strFilters = filters.join( "," );

            strNewPath += "&f=" + strFilters;
        }

        if ( window.location.hash )
        {
            strNewPath += window.location.hash;
        }

        let currentPath = window.location.pathname + window.location.search + window.location.hash;

        if (currentPath !== strNewPath)
        {
            history.replaceState({}, '', strNewPath);
        }
    }

}

function clearURL ()
{
    if ( 'URLSearchParams' in window )
    {
        let searchParams = new URLSearchParams( window.location.search );

        searchParams.forEach( ( value, key ) => searchParams.delete( key ) );

    }

    history.replaceState( null, '', window.location.pathname );
    console.log('clearURL', history)
}

async function handleSearch ( e )
{
    let type = e.detail.type;

    related.value.cleanUp();

    if ( page.value.clearFilters )
    {
        page.value.clearFilters( true );
        store.commit( "clearFilters" );
        store.commit( "clearSearchType" );

    }

    isSearching.value = true;
    store.commit( "results", [] )

    clearURL();

    let searchTerm = e.detail.searchTerm ?? "";

    if ( [ "keyword", "mot_cle" ].includes( type ) )
    {
        //store.commit("searchType", "mot_cle");

        await store.dispatch( "search", { "searchType" : "mot_cle", searchTerm } );
        addToHistory( { "searchType" : "mot_cle", searchTerm } );
    } else if ( [ "descripteurs" ].includes( type ) )
    {
        await store.dispatch( "search", { "searchType" : "descripteurs", searchTerm, "id" : e.detail.searchId } );
        //addToHistory( {"searchType": "mot_cle", "searchTerm" :e.detail.searchTerm ?? ""});
    } else
    {
        await store.dispatch( "search", { searchTerm } );
        addToHistory( { searchTerm } );
    }


    if ( page.value.changePage )
    {
        page.value.changePage( 1 );
    }

    searchInput.value = searchTerm; //This was added, then remove per CCDMD request 2022-10-27 Martin T.

    updateURL();

    isSearching.value = false;
    await store.dispatch( "related" );


}

function prepareSearchBar ()
{
    window.addEventListener( "adf-search", ( e ) => handleSearch( e ) );
}

function setFavourites ( favourites )
{
    store.commit( "favourites", favourites );
}

function addToHistory ( search )
{
    let strHistory = window.localStorage.getItem( "historique" ) ?? "[]";
    let history    = JSON.parse( strHistory );

    history     = history.filter( h => (h.searchType !== search.searchType) || (h.searchTerm !== search.searchTerm) )
    search.date = Date.now();
    history.push( search );

    strHistory = JSON.stringify( history );

    window.localStorage.setItem( "historique", strHistory );

/*console.log(('addToHistory', search))*/;}

function getSearchTermsFromType ( searchType )
{
    if ( searchType === "descripteurs" )
    {
        return "";//querystring.descripteurs;
    }

    return querystring.s;
}


function mounted ()
{
    window.__setFavourites__ = setFavourites;

    let copydeck       = inject( "copydeck" );
    let initialResults = inject( "initialResults" );
    let filters        = inject( "filters" );
    let type           = inject( "type" );

    let searchType = querystring.type ?? "";
    let searchTerm = getSearchTermsFromType( searchType );//querystring.s ?? "";
    let searchId   = parseInt( querystring.id ?? "0" );

    store.commit( "copydeck", copydeck )
    store.commit( "filters", filters );
    store.commit( "results", initialResults );
    store.commit( "searchType", searchType );
    store.commit( "searchTerm", searchTerm );

    ready.value = true;

    if ( searchType === '' )
    {
        searchInput.value = searchTerm;
    }

    store.dispatch( "related" )


    prepareSearchBar();
    addToHistory( { searchType, searchTerm, searchId } );


    store.commit( "detectSize" );

    if ( store.getters.isMobile )
    {
        store.commit( "closeFilters" );
    } else
    {
        store.commit( "openFilters" );
    }

    window.addEventListener( 'resize', debounce( () =>
    {
/*console.log(( 'resize' ))*/;        store.commit( "detectSize" );
    }, 100 ) );


    document.addEventListener( 'keydown', KeydownEvents.bind( this, store ) );
}

//Lifecycle
onMounted( mounted );


</script>

<style scoped>

</style>
